import React, { useState, useEffect } from "react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import "./index.css";

import { RelatorioPorGleba } from "../PanelGerarRelatorios/components/RelatorioPorGleba/index";

import { RelatorioAgrupado } from "./components/RelatorioAgrupado";
import { ExportarExcel } from "./components/ExportarExcel";
import { ResumoCompras } from "./components/ResumoCompras";
import { CadastroExcel } from "./components/CadastroExcel";
const PanelGerarRelatorios = () => {
  return (
    <>
      <ToastContainer position="top-right" autoClose={5000} theme="light" />
      <div
        style={{ width: "65%" }}
        className="panel-container-insumos"
      >
        <div className="header-panel-insumos"> Gerar Relatórios </div>
        <RelatorioPorGleba />
        <RelatorioAgrupado />{" "}
      </div>

      <div
        style={{ width: "65%" }}
        className="panel-container-insumos"
      >
        <div
          className="header-panel-insumos"
          style={{ marginTop: "20px" }}
        >
          Gerar Relatório (Excel)
        </div>
        <ExportarExcel />
      </div>

      <div
        style={{ width: "65%" }}
        className="panel-container-insumos"
      >
        <div
          className="header-panel-insumos"
          style={{ marginTop: "20px" }}
        >
          Resumo (Excel)
        </div>
        <ResumoCompras />
      </div>

      <div
        style={{ width: "65%" }}
        className="panel-container-insumos"
      >
        <div
          className="header-panel-insumos"
          style={{ marginTop: "20px" }}
        >
          Cadastro — Produtores, Fazendas e Talhões (Excel)
        </div>
        <CadastroExcel />
      </div>
    </>
  );
};

export default PanelGerarRelatorios;
